"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Giphy1Schema = void 0;
exports.Giphy1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/giphy-videoclip/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Giphy1",
    "description": "Embed a video clip from Giphy",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:giphy-videoclip:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "id": {
                    "type": "string",
                    "description": "The Giphy ID (e.g. feqkVgjJpYtjy)"
                }
            },
            "required": [
                "id"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9naXBoeS12aWRlb2NsaXAvMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxZQUFZLEdBQUc7SUFDMUIsS0FBSyxFQUFFLG9GQUFvRjtJQUMzRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxRQUFRO0lBQ2pCLGFBQWEsRUFBRSwrQkFBK0I7SUFDOUMsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLDRDQUE0QzthQUM3QztTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsWUFBWSxFQUFFO2dCQUNaLElBQUksRUFBRTtvQkFDSixNQUFNLEVBQUUsUUFBUTtvQkFDaEIsYUFBYSxFQUFFLG1DQUFtQztpQkFDbkQ7YUFDRjtZQUNELFVBQVUsRUFBRTtnQkFDVixJQUFJO2FBQ0w7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsWUFBWTtRQUNaLE1BQU07S0FDUDtDQUNGLENBQUEifQ==